import { Card, CardContent, CardFooter, CardHeader } from '@ui/card.tsx';
import { Skeleton } from '@ui/skeleton.tsx';

const ProductCardSkeleton = () => (
  <Card className="flex flex-col border-0">
    <CardHeader className="flex-row flex-wrap p-3 space-y-0">
      <div className="w-2/6 p-3 mx-auto min-w-24 max-w-32">
        <Skeleton className="w-full aspect-square rounded-xl" />
      </div>

      <div className="w-4/6 p-3 grow">
        <Skeleton className="w-4/5 h-8 mb-2" />
        <Skeleton className="w-3/5 h-8" />
      </div>
    </CardHeader>

    <CardContent className="flex flex-col justify-end space-y-5 max-h-40">
      <div className="relative overflow-hidden">
        <Skeleton className="w-full h-4 mb-2" />
        <Skeleton className="w-5/6 h-4 mb-2" />
        <Skeleton className="w-4/6 h-4" />
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-white to-transparent" />
      </div>

      <div className="flex items-center gap-2">
        <Skeleton className="w-24 h-6" />
        <Skeleton className="w-6 h-6 rounded-full" />
      </div>
    </CardContent>

    <CardFooter className="items-end gap-5 grow">
      <Skeleton className="w-full h-10 rounded-full" />
      <Skeleton className="w-10 h-10 rounded-full" />
    </CardFooter>
  </Card>
);

export { ProductCardSkeleton };
